module.exports = __webpack_public_path__ + "img/bt.3fa9f450.svg";